import React from 'react';

const EmailIcon = props => (
  <svg
    {...props}
    width={20}
    height={20}
    viewBox="0 0 612 612"
    x="0px"
    y="0px"
    style={{ enableBackground: 'new 0 0 512.001 512.001' }}
  >
    <g>
      <path
        fill="black"
        d="M511.646,126.634c-0.021-14.449-11.782-26.189-26.227-26.189c-0.012,0-0.024,0-0.034,0L26.19,101.076
			c-7.005,0.009-13.588,2.746-18.535,7.706C2.709,113.743-0.009,120.334,0,127.337l0.355,258.029
			c0.009,7.005,2.746,13.588,7.706,18.535c4.951,4.938,11.526,7.655,18.519,7.655c0.012,0,0.025,0,0.035,0l459.194-0.631
			c14.458-0.02,26.207-11.799,26.19-26.261L511.646,126.634z M456.611,126.71L256.02,266.154L55.04,127.262L456.611,126.71z
			 M340.846,292.471l118.971,92.265l-407.972,0.56l119.696-92.825c5.722-4.439,6.764-12.675,2.326-18.399
			c-4.439-5.722-12.675-6.764-18.399-2.326L26.561,371.715l-0.32-232.475l222.344,153.657c2.244,1.551,4.849,2.325,7.455,2.325
			c2.617,0,5.236-0.783,7.485-2.346l221.912-154.264l0.336,233.066l-128.856-99.931c-5.719-4.437-13.959-3.396-18.397,2.326
			C334.081,279.795,335.122,288.033,340.846,292.471z"
      />
    </g>
  </svg>
);
export default EmailIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/Email.js